<template>
  <TeamTaskTable />
</template>

<script>
import TeamTaskTable from '../../components/teamtask/Table.vue'
export default {
components: {
  TeamTaskTable
}
}
</script>

<style>

</style>